<template>
  <v-autocomplete
    v-model="localSelected"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    :label="label"
    v-on:change="changeSelect"
    item-text="text"
    item-value="value"
    autocomplete="off"
    cache-items
    clearable
    return-object
    :rules="[rules.required]"
  ></v-autocomplete>
</template>

<script>
import API from '@/services/api.js'
import { RulesMixin } from '@/components/mixins'
// @group Common
// PersonAutocomplete component
export default {
  name: 'PersonAutocomplete',
  mixins: [RulesMixin],
  props: {
    // selectFn :- is name of the API call ,it is String and is Required
    selectFn: { type: String, required: true },

    // label :- is the label of the field, it is String and is Required
    label: { type: String, required: true },

    // defaultSelectFn :- is name of the API call to get the default selected ,it is String and is Required
    defaultSelectFn: { type: String, required: true },

    // Selected :- is the Id of the selected Person called in defaultSelectFn
    Selected: { type: Number, required: false }
  },

  data () {
    return {
      loading: false,
      items: [],
      search: null,
      localSelected: '',
      searchVal: ''
    }
  },
  watch: {
    // @vuese
    // Watch the search input in autocomplete and call the querySelections function
    // @arg The argument is a string  value representing {search: value}
    search (val) {
      if (this.Selected !== val) {
        this.searchVal = val
        this.querySelections()
      }

    },
    // @vuese
    // Watch the route if user comes back in the same component ,call the querySelections function
    // @arg The argument is a Selected default Id  value representing getSelectedPerson(id)
    $route: function () {
      this.getSelectedPerson()
    },
    Selected () {
      this.getSelectedPerson()

    }
  },
  created () {
    // @vuese
    // Used to call getSelectedPerson function on create
    this.getSelectedPerson()
  },
  methods: {
    // @vuese
    // Used get the getSelectedPerson if there is any
    // @arg The argument is a Selected default Id  value representing getSelectedPerson(id)
    getSelectedPerson () {
      if (this.Selected > 0) {
        API[this.defaultSelectFn](this.Selected)
          .then(response => {

            let selectedName = []
            selectedName.push({
              text: response.data.firstName + ' ' + response.data.lastName + ' (' + response.data.personalNumber + ')',
              value: response.data.id
            }
            )

            this.items = selectedName
            this.localSelected = response.data.id
          })
          .catch(error => {
            console.log('get users', error.response)
          })
      }

    },

    // @vuese
    // Used to get the results of the search input field from db
    // API[this.selectFn] :- get the function name from props
    // @arg The argument is a string  value representing {search: value}
    querySelections () {

      this.loading = true

      API[this.selectFn]({ search: this.searchVal })
        .then(response => {

          this.loading = false
          let names = []

          response.data.map(function (obj) {
            names.push({ text: obj.firstName + ' ' + obj.lastName + ' (' + obj.personalNumber + ')',
              value: obj.id })
          })

          this.items = names
        })
        .catch(error => {
          console.log('get users', error.response)
        })
    },
    changeSelect (val) {
      if (val !== undefined) {
        
        // Fire when something is selected
        // @arg The argument is a object value representing name and id selected
        this.$emit('selAutoComplete', val)
      }

    }
  }
}
</script>
